import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-center px-6 kitchen-bg">
          <p className="font-hand text-2xl">something spilled in the fridge.</p>
          <p className="font-display text-2xl">WE WILL MOP IT UP</p>
          <button className="btn-cartoon" onClick={() => window.location.reload()}>
            reopen the fridge
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}